import type { ThirdPartyOrder } from '@biteinc/db-models';
import { MathHelper, StringHelper } from '@biteinc/helpers';

export function getOrderGuestInfoText(
  order: Pick<ThirdPartyOrder.Data, 'guestName' | 'guestEmail' | 'guestPhoneNumber'>,
): string {
  return [
    order.guestName,
    order.guestEmail,
    order.guestPhoneNumber && StringHelper.toFormattedPhoneNumber(order.guestPhoneNumber),
  ]
    .filter(Boolean)
    .join(', ');
}

export function getOrderFinancialsText(
  order: Pick<
    ThirdPartyOrder.ParsedData,
    | 'subTotal'
    | 'discountTotal'
    | 'taxTotal'
    | 'tipTotal'
    | 'serviceChargeTotal'
    | 'donationTotal'
    | 'total'
  >,
  hasDiscounts: boolean,
): string {
  let financials = `Sub: $${MathHelper.displayPrice(order.subTotal)}`;
  if (order.discountTotal >= 0 && hasDiscounts) {
    financials += `  Discount: $${MathHelper.displayPrice(order.discountTotal)}`;
  }
  if (order.taxTotal !== undefined && order.taxTotal !== null) {
    financials += `  Tax: $${MathHelper.displayPrice(order.taxTotal)}`;
  }
  if (order.tipTotal > 0) {
    financials += `  Tip: $${MathHelper.displayPrice(order.tipTotal)}`;
  }
  if (order.serviceChargeTotal > 0) {
    financials += `  Service Charge: $${MathHelper.displayPrice(order.serviceChargeTotal)}`;
  }
  if (order.donationTotal > 0) {
    financials += `  Donation: $${MathHelper.displayPrice(order.donationTotal)}`;
  }
  if (order.total !== undefined && order.total !== null) {
    financials += `  Grand: $${MathHelper.displayPrice(order.total)}`;
  }
  return financials;
}
